import { useMutation, useQueryClient } from '@tanstack/react-query';
import { editAppConfig } from 'api/appManager';
import { LIST_APP_QUERY } from 'constants/QueryString';

const useEditConfiguration = () => {
  const queryClient = useQueryClient();

  const {
    data,
    error,
    isError,
    isIdle,
    isPending,
    isPaused,
    isSuccess,
    failureCount,
    failureReason,
    mutate,
    mutateAsync,
    reset,
    status,
    submittedAt,
    variables,
    isLoading,
  } = useMutation({
    mutationFn: editAppConfig,
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: [LIST_APP_QUERY] });
    },
    onError: (error) => {
      console.error('Error editing app configuration:', error);
      // Handle the error, show error message, etc.
    },
  });
  return {
    data,
    error,
    isError,
    isIdle,
    isPending,
    isPaused,
    isSuccess,
    failureCount,
    failureReason,
    mutate,
    mutateAsync,
    reset,
    status,
    submittedAt,
    variables,
    isLoading,
  };
};

export default useEditConfiguration;
